import { createSelector } from '@reduxjs/toolkit';

export const selectAuthSlice = (state) => state.auth;

export const selectUser = createSelector([selectAuthSlice], (authSlice) => authSlice.user);

export const selectIsUserDataRequested = createSelector([selectAuthSlice], (authSlice) => authSlice.isUserDataRequested);
